export default defineNuxtRouteMiddleware((to, from) => {
  const getNextRoute = (nextPath: string) => {
    return { path: nextPath, query, hash };
  };
  const context = useContextStore();
  if (!context.isLoggedIn) return;
  const profile = useProfileStore();
  const { path, query, hash } = to;

  if (path === '/' || path.indexOf(`/${Sections.InTheNews}`) === 0) {
    if (!profile.isParent && !profile.featureFlags.home) {
      return navigateTo(getNextRoute(`/${Sections.Revisions}`), {
        redirectCode: 301,
      });
    }
  }

  if (path.indexOf(`/${Sections.ChildForYou}`) === 0) {
    if (!profile.isParent && profile.featureFlags.forYou === false) {
      return navigateTo(getNextRoute(`/${Sections.Revisions}`), {
        redirectCode: 301,
      });
    }
  }
});
